module.exports = __webpack_public_path__ + "static/media/usina-ieadpe-tiuma.c5aa8f78.jpg";